import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import type { MapStore } from "@/components/Map/stores/MapStore";
import type { TimePeriodsValue } from "@/config/date";
import { RainGaugePopup, type RainGaugeStation } from "./RainGaugePopup";

const DEFAULT_TIME_PERIOD: TimePeriodsValue = "last1y";

interface RainGaugeProps {
	mapStore: MapStore<any>;
	timePeriod?: TimePeriodsValue;
}

export const RainGauge = observer(({ mapStore, timePeriod = DEFAULT_TIME_PERIOD }: RainGaugeProps) => {
	const { rainStore } = mapStore;
	const [station, setStation] = useState<RainGaugeStation | null>(null);

	useEffect(() => {
		if (!mapStore.isLoaded) return;
		rainStore.rainLayers.gaugeMarkers
			.onMouseEnter(({ map }) => {
				(map.getCanvas() as HTMLCanvasElement).style.cursor = "pointer";
			})
			.onMouseLeave(({ map }) => {
				(map.getCanvas() as HTMLCanvasElement).style.cursor = "";
			})
			.onClick(({ feature, lng, lat }) => {
				const properties = feature.properties || {};
				setStation({
					id: String(properties.id || ""),
					name: String(properties.name || properties.station_name || "Unknown Station"),
					provider: String(properties.provider || properties.source || ""),
					lng,
					lat,
				});
			});
	}, [mapStore.isLoaded, rainStore]);

	if (!station) return null;
	return <RainGaugePopup station={station} timePeriod={timePeriod} onClose={() => setStation(null)} />;
});
